import { useContext } from 'react';
import { CommentsContext } from "../context/comments.js";
export const useComments = () => useContext(CommentsContext);
//# sourceMappingURL=use-comments.js.map